@if (!isPlaceholder) {
  <div class="message-container">
    @if (message.isResponse) {
      <div class="icon">
          <mat-icon [svgIcon]="'hemro:icon'" class="icon-size-8"></mat-icon>
      </div>
    }
    <div class="content" [class.mine]="!message.isResponse">
      <div class="message">
        @if (message.isResponse) {
          @if (!message.typingEffect) {
            <span [innerHTML]="message?.payload | safeHtml"></span>
          }
          @if (message.typingEffect) {
            @if (!message.isTyping) {
              <span [innerHTML]="message?.payload | safeHtml"></span>
            }
            @if (message.isTyping) {
              <span
                typewriter
                [message]="message?.payload"
                [typingSpeed]="100"
                (typingStatus)="onTypingStatusChange($event)"
                (stopTyping)="onStopTyping($event)"
                (keepScrollDown)="keepScrollDown.emit($event)">
              </span>
            }
          }
        } @else {
          {{ message?.payload }}
        }
      </div>
      @if (message.isResponse && !message.isTyping) {
        <div class="reaction">
          <button mat-icon-button disableRipple (click)="onFeedback('like')"
            [disabled]="message.feedbackLoading"
            [class.active]="message.rating === 1">
            <mat-icon svgIcon="heroicons_outline:like"></mat-icon>
          </button>
          <button mat-icon-button [disableRipple]="true" (click)="onFeedback('dislike')"
            [disabled]="message.feedbackLoading"
            [class.active]="message.rating === -1">
            <mat-icon svgIcon="heroicons_outline:dislike"></mat-icon>
          </button>
          <button mat-icon-button [disableRipple]="true" (click)="onFeedback('refresh')"
            [disabled]="message.feedbackLoading">
            <mat-icon svgIcon="heroicons_outline:refresh" class="icon-size-5"></mat-icon>
          </button>
        </div>
      }
    </div>
  </div>
} @else {
  <div class="flex items-center gap-x-4 px-1">
    <div class="icon">
      <img src="assets/icons/favicon.svg" alt="logo" width="32" height="32">
    </div>
    <div class="typing-dots">...</div>
  </div>
}


